/* Frinta — the small amount of behaviour the theme actually needs.
   No framework: every section renders server-side. */
(function () {
  'use strict';

  /* --- variant selection ------------------------------------------------ */

  document.querySelectorAll('.form--product').forEach(function (form) {
    var input = form.querySelector('[data-variant-input]');
    var addBtn = form.querySelector('[data-add-button]');
    if (!input) return;

    var selected = ['', ''];
    form.querySelectorAll('[data-option]').forEach(function (btn) {
      if (btn.getAttribute('aria-pressed') === 'true') {
        selected[Number(btn.dataset.option)] = btn.dataset.value;
      }
    });

    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option]');
      if (!btn || btn.classList.contains('chip--oos')) return;

      var group = Number(btn.dataset.option);
      selected[group] = btn.dataset.value;

      form.querySelectorAll('[data-option="' + group + '"]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });

      var label = form.querySelector('[data-option-value="' + group + '"]');
      if (label) label.textContent = btn.dataset.value;

      var variant = (window.__frintaVariants || []).find(function (v) {
        return v.option1 === selected[0] && v.option2 === selected[1];
      });

      if (variant) {
        input.value = variant.id;
        if (addBtn) {
          addBtn.disabled = !variant.available;
          addBtn.textContent = variant.available ? 'Ajouter au panier' : 'Épuisé';
        }
      }
    });
  });

  /* --- gallery thumbs --------------------------------------------------- */

  var thumbs = document.querySelectorAll('[data-thumb]');
  var slides = document.querySelectorAll('[data-slide]');
  var dots = document.querySelectorAll('[data-dot]');
  var navs = document.querySelectorAll('[data-nav]');
  var track = document.querySelector('[data-slides]');
  if (!slides.length) return;

  // Below 750px the slides are a snap scroller; above it only one is displayed.
  function isScroller() { return track && track.scrollWidth > track.clientWidth + 1; }

  function current() {
    if (isScroller()) return Math.round(track.scrollLeft / track.clientWidth);
    for (var i = 0; i < slides.length; i++) if (slides[i].classList.contains('is-active')) return i;
    return 0;
  }

  function paint(i) {
    thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
    dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    navs.forEach(function (b) {
      var d = Number(b.dataset.nav);
      b.disabled = (d < 0 && i === 0) || (d > 0 && i === slides.length - 1);
    });
  }

  function goTo(i) {
    i = Math.max(0, Math.min(slides.length - 1, i));
    if (isScroller()) {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    } else {
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    }
    paint(i);
  }

  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
  dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
  navs.forEach(function (b) {
    b.addEventListener('click', function () { goTo(current() + Number(b.dataset.nav)); });
  });

  if (track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking || !isScroller()) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; paint(current()); });
    });
  }
  paint(0);
})();

/* ------------------------------------------------------------- hover zoom --- */
/* Scales the main product image under the pointer. Skipped on touch and when
   the visitor has asked for reduced motion. */
(function () {
  'use strict';

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!fine || still) return;

  var ZOOM = 2.1;

  document.querySelectorAll('.pdp__slide').forEach(function (box) {
    var img = box.querySelector('img');
    if (!img) return;
    var frame = null;

    function place(e) {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var r = box.getBoundingClientRect();
        var x = Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100));
        var y = Math.min(100, Math.max(0, ((e.clientY - r.top) / r.height) * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
      });
    }

    box.addEventListener('mouseenter', function (e) {
      place(e);
      box.classList.add('is-zoomed');
      img.style.transform = 'scale(' + ZOOM + ')';
    });
    box.addEventListener('mousemove', place);
    box.addEventListener('mouseleave', function () {
      if (frame) { cancelAnimationFrame(frame); frame = null; }
      box.classList.remove('is-zoomed');
      img.style.transform = '';
      img.style.transformOrigin = 'center';
    });
  });
})();

/* -------------------------------------------------------------- mobile nav --- */
/* The desktop nav row is hidden below 900px, so this drawer is the only way to
   navigate on a phone. Handles Escape, scrim clicks, body scroll lock, and
   returns focus to the button that opened it. */
(function () {
  'use strict';

  var drawer = document.getElementById('menu-drawer');
  if (!drawer) return;

  var openers = document.querySelectorAll('[data-drawer-open]');
  var panel = drawer.querySelector('.drawer__panel');
  var lastFocused = null;

  function focusable() {
    return panel.querySelectorAll('a[href], button:not([disabled])');
  }

  function open(trigger) {
    lastFocused = trigger || document.activeElement;
    drawer.hidden = false;
    // Next frame, so the transition runs from the off-screen position.
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.classList.add('drawer-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var first = focusable()[0];
    if (first) first.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var done = function () { drawer.hidden = true; panel.removeEventListener('transitionend', done); };
    panel.addEventListener('transitionend', done);
    // Fallback when transitions are disabled.
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 400);
    if (lastFocused) lastFocused.focus();
  }

  openers.forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
  drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (drawer.hidden) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var items = focusable();
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();

/* ------------------------------------------------------------- back link --- */
/* If the visitor arrived from a collection on this site, go back through
   history so the browser restores their place in the grid. Otherwise the href
   stands, which is what happens when someone lands on a product directly from
   an ad or a search result. */
(function () {
  'use strict';

  var link = document.querySelector('[data-back]');
  if (!link || !document.referrer) return;

  var from;
  try { from = new URL(document.referrer); } catch (e) { return; }
  if (from.origin !== window.location.origin) return;
  if (!/\/collections\//.test(from.pathname)) return;

  link.addEventListener('click', function (e) {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    history.back();
  });
})();

/* ------------------------------------------------- collection scroll memory --- */
/* Returning to a 28-product grid at the top is a real cost on a phone.
 * history.back() alone is unreliable: the images below the fold are lazy, so at
 * restore time the document is shorter than it was and the browser clamps the
 * position (measured: 1600 -> 764).
 *
 * The listeners are registered unconditionally. An earlier version bailed out
 * when nothing was stored yet, which meant the very first visit to the grid
 * never armed the handler that the return trip depends on. */
(function () {
  'use strict';

  var KEY = 'frinta:grid-scroll';
  var MAX_AGE = 30 * 60 * 1000;
  if (!/\/collections\//.test(window.location.pathname)) return;

  function read() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }
  function write(v) {
    try { sessionStorage.setItem(KEY, JSON.stringify(v)); } catch (e) { /* private mode */ }
  }

  // Remember the position when following a product link.
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href*="/products/"]') : null;
    if (!a) return;
    write({ path: window.location.pathname, y: window.scrollY, at: Date.now() });
  });

  function restore() {
    var saved = read();
    if (!saved || saved.path !== window.location.pathname) return;
    if (Date.now() - saved.at > MAX_AGE || saved.y < 200) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    var tries = 0;
    (function step() {
      window.scrollTo(0, saved.y);
      // Lazy images resolve over several frames; keep nudging until the
      // document is tall enough to actually hold the position.
      if (++tries < 20 && Math.abs(window.scrollY - saved.y) > 4) setTimeout(step, 60);
    })();
  }

  restore();
  window.addEventListener('load', restore);
  // Fires on back/forward, including a bfcache restore where nothing re-parses.
  window.addEventListener('pageshow', restore);
})();

/* --------------------------------------------------------------- buy bar --- */
/* Reveals a sticky Ajouter au panier once the real one has scrolled out of
 * view. The bar's button proxies the real button rather than owning a second
 * form, so the selected variant and the disabled state have one source of
 * truth and cannot drift apart. */
(function () {
  'use strict';

  var bar = document.querySelector('[data-buybar]');
  var form = document.querySelector('.form--product');
  if (!bar || !form) return;

  var realBtn = form.querySelector('[data-add-button]');
  var proxy = bar.querySelector('[data-buybar-add]');
  var variantOut = bar.querySelector('[data-buybar-variant]');
  var priceOut = bar.querySelector('[data-buybar-price]');
  var pagePrice = document.querySelector('.pdp__price');
  if (!realBtn || !proxy) return;

  proxy.addEventListener('click', function () { realBtn.click(); });

  function sync() {
    proxy.disabled = realBtn.disabled;
    proxy.textContent = realBtn.textContent.trim();
    if (priceOut && pagePrice) priceOut.innerHTML = pagePrice.innerHTML;
    if (variantOut) {
      var parts = [];
      form.querySelectorAll('[data-option]').forEach(function (b) {
        if (b.getAttribute('aria-pressed') === 'true') parts.push(b.dataset.value);
      });
      if (parts.length) variantOut.textContent = parts.join(' · ');
    }
  }
  // Option clicks bubble to the form; run after the variant handler has updated.
  form.addEventListener('click', function () { setTimeout(sync, 0); });
  sync();

  function show(on) {
    if (on) {
      bar.hidden = false;
      requestAnimationFrame(function () { bar.classList.add('is-visible'); });
    } else {
      bar.classList.remove('is-visible');
    }
  }

  /* IntersectionObserver alone proved unreliable here: its entry carries the
     rect captured when the threshold was crossed, which after a large scroll
     jump can still describe the button as below the fold. Reading the live
     rect on a throttled scroll is deterministic and cheap enough. */
  var pending = false;
  function evaluate() {
    show(realBtn.getBoundingClientRect().bottom < 0);
  }
  function onScroll() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; evaluate(); });
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  evaluate();
})();

/* ----------------------------------------------------------- cart drawer --- */
/* Opens from the right instead of navigating to /cart, and opens itself when
 * something is added. Talks to Shopify's AJAX cart endpoints (/cart.js,
 * /cart/add.js, /cart/change.js), so the behaviour is identical in production.
 * The cart icon stays a real link, so with JS off it still reaches /cart. */
(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var panel = drawer.querySelector('.drawer__panel');
  var body = drawer.querySelector('[data-cart-body]');
  var lines = drawer.querySelector('[data-cart-lines]') || body;
  var recs = drawer.querySelector('[data-cart-recs]');
  var foot = drawer.querySelector('[data-cart-foot]');
  var totalOut = drawer.querySelector('[data-cart-total]');
  var headCount = drawer.querySelector('[data-cart-head-count]');
  var badge = document.querySelector('[data-cart-count]');
  var openers = document.querySelectorAll('[data-cart-open]');
  var emptyTpl = drawer.querySelector('[data-cart-empty]');
  var trashTpl = drawer.querySelector('[data-icon-trash]');
  var trashIcon = trashTpl ? trashTpl.innerHTML : '×';
  var lastFocused = null;

  function money(cents) {
    if (cents === null || cents === undefined) return '—,— €';
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function render(cart) {
    var count = cart.item_count || 0;

    if (badge) {
      badge.textContent = count;
      badge.hidden = count === 0;
    }
    if (headCount) headCount.textContent = count ? '(' + count + ')' : '';

    body.classList.toggle('is-empty', !count);

    if (!count) {
      // Cloned from the Liquid <template>, so the copy and the link stay
      // editable in the theme editor instead of being duplicated here.
      lines.innerHTML = emptyTpl ? emptyTpl.innerHTML : '<p class="cartd__empty">Votre panier est vide.</p>';
      foot.hidden = true;
      // The empty state has its own call to action; a cross-sell row on top of
      // it would just be clutter.
      if (recs) recs.hidden = true;
      return;
    }

    lines.innerHTML = cart.items.map(function (i) {
      var img = i.image && i.image.src ? i.image.src : '/_placeholder.svg?w=120&h=160';
      return '<div class="cartd__line">'
        + '<div class="cartd__media"><img src="' + esc(img) + '" alt="" width="64" height="85"></div>'
        + '<div>'
        +   '<p class="cartd__name">' + esc(i.product_title) + '</p>'
        +   '<p class="cartd__variant">' + esc(i.variant_title) + '</p>'
        +   '<div class="cartd__actions">'
        +     '<div class="cartd__qty">'
        +       '<button type="button" data-qty="' + esc(i.key) + '" data-to="' + (i.quantity - 1) + '" aria-label="Retirer un">−</button>'
        +       '<span>' + i.quantity + '</span>'
        +       '<button type="button" data-qty="' + esc(i.key) + '" data-to="' + (i.quantity + 1) + '" aria-label="Ajouter un">+</button>'
        +     '</div>'
        +     '<button class="cartd__remove" type="button" data-remove="' + esc(i.key) + '"'
        +       ' aria-label="Retirer ' + esc(i.product_title) + ' du panier" title="Retirer">' + trashIcon + '</button>'
        +   '</div>'
        + '</div>'
        + '<div class="cartd__price">' + money(i.line_price) + '</div>'
        + '</div>';
    }).join('');

    totalOut.textContent = money(cart.total_price);
    foot.hidden = false;

    if (recs) {
      // Suggesting something already in the basket wastes the slot.
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.handle] = true; });
      var shown = 0;
      recs.querySelectorAll('[data-rec]').forEach(function (card) {
        var hide = !!inCart[card.dataset.recHandle];
        card.hidden = hide;
        if (!hide) shown++;
      });
      recs.hidden = shown === 0;
    }
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () { /* leave the last known state on screen */ });
  }

  function open(trigger) {
    lastFocused = trigger || document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.classList.add('drawer-open');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    var first = panel.querySelector('button, a[href]');
    if (first) first.focus();
  }

  function close() {
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 400);
    if (lastFocused) lastFocused.focus();
  }

  openers.forEach(function (o) {
    o.addEventListener('click', function (e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;   // let people open /cart in a new tab
      e.preventDefault();
      open(o);
      refresh();
    });
  });

  drawer.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    var rec = e.target.closest('[data-rec-add]');
    if (rec) {
      rec.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams({ id: rec.dataset.recAdd, quantity: 1 }),
      })
        .then(function (r) { return r.json(); })
        .then(function () { return refresh(); })
        .finally(function () { rec.disabled = false; });
      return;
    }

    var rm = e.target.closest('[data-remove]');
    if (rm) {
      rm.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams({ id: rm.dataset.remove, quantity: 0 }),
      }).then(function (r) { return r.json(); }).then(render);
      return;
    }

    var q = e.target.closest('[data-qty]');
    if (!q) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
      body: new URLSearchParams({ id: q.dataset.qty, quantity: q.dataset.to }),
    }).then(function (r) { return r.json(); }).then(render);
  });

  document.addEventListener('keydown', function (e) {
    if (!drawer.hidden && e.key === 'Escape') close();
  });

  /* Adding should open the drawer rather than reload the page. */
  var form = document.querySelector('.form--product');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams(data),
      })
        .then(function (r) { return r.json(); })
        .then(function () { open(); return refresh(); })
        .catch(function () { form.submit(); });   // fall back to a normal post
    });
  }

  // /cart redirects here and leaves a flag; open the drawer on arrival.
  try {
    if (sessionStorage.getItem('frinta:open-cart')) {
      sessionStorage.removeItem('frinta:open-cart');
      open();
    }
  } catch (e) { /* private mode */ }

  refresh();
})();

/* --------------------------------------------------------- size calculator --- */
/* French bra sizing. The band and cup tables below are the usual French
   convention; they are indicative and must be checked against Frinta's real
   patterns before launch. The page says so too — see the caveat block. */
(function () {
  'use strict';

  var root = document.querySelector('[data-calc]');
  if (!root) return;

  var BANDS = [
    { min: 63, max: 67.99, fr: 80 },
    { min: 68, max: 72.99, fr: 85 },
    { min: 73, max: 77.99, fr: 90 },
    { min: 78, max: 82.99, fr: 95 },
    { min: 83, max: 87.99, fr: 100 },
    { min: 88, max: 92.99, fr: 105 },
  ];
  var CUPS = [
    { min: 12, max: 13.99, cup: 'A' },
    { min: 14, max: 15.99, cup: 'B' },
    { min: 16, max: 17.99, cup: 'C' },
    { min: 18, max: 19.99, cup: 'D' },
    { min: 20, max: 21.99, cup: 'E' },
    { min: 22, max: 23.99, cup: 'F' },
  ];
  /* Provisional: confirm against the finished patterns. */
  var SETS = { 80: 'S', 85: 'S', 90: 'M', 95: 'L', 100: 'XL', 105: 'XL' };

  var unit = 'cm';
  var bandEl = root.querySelector('[data-band]');
  var bustEl = root.querySelector('[data-bust]');
  var out = root.querySelector('[data-calc-out]');

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function show(html) {
    out.innerHTML = html;
    out.hidden = false;
  }

  function error(msg) {
    show('<div class="calc__error">' + esc(msg) + '</div>');
  }

  root.querySelectorAll('[data-unit]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.dataset.unit === unit) return;
      unit = btn.dataset.unit;
      root.querySelectorAll('[data-unit]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b === btn));
      });
      // Convert whatever is already typed rather than making them retype it.
      [bandEl, bustEl].forEach(function (el) {
        var v = parseFloat(el.value);
        if (!isNaN(v)) el.value = (unit === 'in' ? v / 2.54 : v * 2.54).toFixed(1);
      });
      var ph = unit === 'in' ? ['ex. 30', 'ex. 35'] : ['ex. 75', 'ex. 90'];
      bandEl.placeholder = ph[0];
      bustEl.placeholder = ph[1];
      out.hidden = true;
    });
  });

  root.querySelector('[data-calc-go]').addEventListener('click', function () {
    var band = parseFloat(bandEl.value);
    var bust = parseFloat(bustEl.value);

    if (isNaN(band) || isNaN(bust)) {
      return error('Renseignez les deux mesures pour lancer le calcul.');
    }
    if (unit === 'in') { band *= 2.54; bust *= 2.54; }

    if (bust <= band) {
      return error('Le tour de poitrine doit être supérieur au tour de dos. Vérifiez que le ruban passe bien sur la partie la plus forte.');
    }

    var b = BANDS.find(function (r) { return band >= r.min && band <= r.max; });
    if (!b) {
      return error('Cette mesure de dos (' + band.toFixed(1) + ' cm) sort de notre grille actuelle, qui va de 63 à 92 cm. Écrivez-nous, nous vous orienterons.');
    }

    var diff = bust - band;
    var c = CUPS.find(function (r) { return diff >= r.min && diff <= r.max; });
    if (!c) {
      return error('L’écart entre vos deux mesures (' + diff.toFixed(1) + ' cm) sort de notre grille de bonnets. Écrivez-nous, nous vous orienterons.');
    }

    var size = b.fr + c.cup;
    var set = SETS[b.fr];

    show(
      '<div class="calc__result">' +
        '<div class="calc__size"><small>Votre taille</small>' + esc(size) + '</div>' +
        '<div>' +
          '<p class="calc__map">Pour nos ensembles, prenez la taille <strong>' + esc(set) + '</strong>.</p>' +
          '<p class="calc__note">Dos ' + band.toFixed(1) + ' cm · poitrine ' + bust.toFixed(1) +
          ' cm · écart ' + diff.toFixed(1) + ' cm. Entre deux tailles, prenez la plus grande — ' +
          'les retours sont gratuits pendant 30 jours.</p>' +
        '</div>' +
      '</div>'
    );
  });

  /* Enter submits from either field. */
  [bandEl, bustEl].forEach(function (el) {
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); root.querySelector('[data-calc-go]').click(); }
    });
  });
})();
